import { render } from "./ContractDetailsForm.vue?vue&type=template&id=13001372&scoped=true"
import script from "./ContractDetailsForm.vue?vue&type=script&lang=js"
export * from "./ContractDetailsForm.vue?vue&type=script&lang=js"

import "./ContractDetailsForm.vue?vue&type=style&index=0&id=13001372&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13001372"]])

export default __exports__